var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetSended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9972 53.4265C95.9106 52.1074 98.1365 51.4493 100.362 51.4493C102.588 51.4493 104.814 52.1102 106.728 53.4265L152.899 85.1996V147.826H47.8262V85.1996L93.9972 53.4265ZM105.157 55.6929C103.741 54.718 102.082 54.2031 100.362 54.2031C98.6425 54.2031 96.9835 54.718 95.5678 55.6929L50.5912 86.6426V145.072H150.134V86.6426L105.157 55.6929Z",
    fill: "#D9E3ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9972 53.4265L94.3669 53.9637L94.3674 53.9634L93.9972 53.4265ZM106.728 53.4265L107.097 52.8892L107.097 52.8892L106.728 53.4265ZM152.899 85.1996H153.551V84.8567L153.268 84.6624L152.899 85.1996ZM152.899 147.826V148.478H153.551V147.826H152.899ZM47.8262 147.826H47.174V148.478H47.8262V147.826ZM47.8262 85.1996L47.4565 84.6624L47.174 84.8567V85.1996H47.8262ZM105.157 55.6929L104.787 56.23L104.787 56.2301L105.157 55.6929ZM95.5678 55.6929L95.9375 56.2301L95.9376 56.23L95.5678 55.6929ZM50.5912 86.6426L50.2215 86.1053L49.9391 86.2997V86.6426H50.5912ZM50.5912 145.072H49.9391V145.724H50.5912V145.072ZM150.134 145.072V145.724H150.786V145.072H150.134ZM150.134 86.6426H150.786V86.2997L150.503 86.1053L150.134 86.6426ZM100.362 50.7971C98.0081 50.7971 95.6524 51.4933 93.6271 52.8895L94.3674 53.9634C96.1689 52.7215 98.2649 52.1015 100.362 52.1015V50.7971ZM107.097 52.8892C105.073 51.4963 102.717 50.7971 100.362 50.7971V52.1015C102.459 52.1015 104.556 52.724 106.358 53.9638L107.097 52.8892ZM153.268 84.6624L107.097 52.8892L106.358 53.9637L152.529 85.7369L153.268 84.6624ZM153.551 147.826V85.1996H152.246V147.826H153.551ZM47.8262 148.478H152.899V147.174H47.8262V148.478ZM47.174 85.1996V147.826H48.4783V85.1996H47.174ZM93.6275 52.8892L47.4565 84.6624L48.1959 85.7369L94.3669 53.9637L93.6275 52.8892ZM100.362 54.8552C101.95 54.8552 103.48 55.3302 104.787 56.23L105.527 55.1557C104.002 54.1058 102.214 53.5509 100.362 53.5509V54.8552ZM95.9376 56.23C97.2443 55.3302 98.7743 54.8552 100.362 54.8552V53.5509C98.5107 53.5509 96.7227 54.1058 95.1979 55.1557L95.9376 56.23ZM50.9609 87.1799L95.9375 56.2301L95.1981 55.1556L50.2215 86.1053L50.9609 87.1799ZM51.2434 145.072V86.6426H49.9391V145.072H51.2434ZM150.134 144.42H50.5912V145.724H150.134V144.42ZM149.481 86.6426V145.072H150.786V86.6426H149.481ZM104.787 56.2301L149.764 87.1799L150.503 86.1053L105.527 55.1556L104.787 56.2301Z",
    fill: "#D9E3ED"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 66.0996,
    y: 61.8684,
    width: 69.1781,
    height: 53.398,
    fill: "white",
    stroke: "#00A8C1",
    strokeWidth: 2.6087
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M50.4368 86.6138V145.221H150.288V86.6138L113.64 110.664L87.4373 111.017L50.4368 86.6138Z",
    fill: "#F3F7FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M114.201 110.396H87.1758L51.2561 84.6602L48.7273 86.4249L86.2549 113.313H115.122L152.65 86.4249L150.121 84.6602L114.201 110.396Z",
    fill: "#D9E3ED",
    stroke: "#D9E3ED",
    strokeWidth: 1.30435
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M121.491 79.4506H79.8863C79.1208 79.4506 78.4995 78.8672 78.4995 78.1483C78.4995 77.4293 79.1208 76.8459 79.8863 76.8459H121.491C122.257 76.8459 122.878 77.4293 122.878 78.1483C122.878 78.8672 122.257 79.4506 121.491 79.4506Z",
    fill: "#00A8C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M110.397 87.265H79.8863C79.1208 87.265 78.4995 86.6815 78.4995 85.9626C78.4995 85.2437 79.1208 84.6602 79.8863 84.6602H110.397C111.162 84.6602 111.783 85.2437 111.783 85.9626C111.783 86.6815 111.162 87.265 110.397 87.265Z",
    fill: "#00A8C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M121.491 95.7305H79.8863C79.1208 95.7305 78.4995 95.147 78.4995 94.4281C78.4995 93.7092 79.1208 93.1257 79.8863 93.1257H121.491C122.257 93.1257 122.878 93.7092 122.878 94.4281C122.878 95.147 122.257 95.7305 121.491 95.7305Z",
    fill: "#00A8C1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Confirm"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 151.152,
    cy: 144.261,
    r: 14.4928,
    fill: "#00A8C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M145.282 144.944C144.889 144.662 144.34 144.75 144.055 145.141C143.77 145.532 143.858 146.078 144.251 146.36L149.295 149.983C149.637 150.229 150.108 150.197 150.415 149.907L159.826 141.007C160.178 140.674 160.192 140.121 159.858 139.772C159.524 139.423 158.968 139.41 158.616 139.742L149.735 148.142L145.282 144.944Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSended);
export default __webpack_public_path__ + "static/media/reset-sended.173575a558f8b34f9747b27834064d71.svg";
export { ForwardRef as ReactComponent };